
import { AppState, UserProfile } from '../types';
import { encryptData, decryptData } from './crypto';

const STORAGE_KEY = 'divine_prosperity_v1';
const PROFILE_KEY = 'divine_prosperity_profile';

export const StorageService = {
  saveProfile: (profile: UserProfile) => {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  },

  getProfile: (): UserProfile | null => {
    const data = localStorage.getItem(PROFILE_KEY);
    return data ? JSON.parse(data) : null;
  },

  saveState: async (state: AppState, pin: string) => {
    const encrypted = await encryptData(state, pin);
    localStorage.setItem(STORAGE_KEY, encrypted);
  },

  getState: async (pin: string): Promise<AppState | null> => {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    if (!encrypted) return null;
    return await decryptData(encrypted, pin);
  },

  clearAll: () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(PROFILE_KEY);
  },

  exportData: async (pin: string): Promise<string> => {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    const profile = localStorage.getItem(PROFILE_KEY);
    return JSON.stringify({ encrypted, profile });
  },

  importData: (jsonData: string) => {
    const data = JSON.parse(jsonData);
    if (data.encrypted) localStorage.setItem(STORAGE_KEY, data.encrypted);
    if (data.profile) localStorage.setItem(PROFILE_KEY, data.profile);
  }
};
